import {
  GET_FRIENDS,
  GET_FRIEND_REQUESTS,
  SEARCH_USERS,
  CLEAR_SEARCH_RESULTS,
  SEND_FRIEND_REQUEST,
  ACCEPT_FRIEND_REQUEST,
  REJECT_FRIEND_REQUEST,
  REMOVE_FRIEND,
  FRIEND_ERROR,
  CLEAR_FRIENDS,
  CLEAR_ERRORS
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case GET_FRIENDS:
      return {
        ...state,
        friends: action.payload,
        loading: false
      };
    
    case GET_FRIEND_REQUESTS:
      return {
        ...state,
        friendRequests: action.payload,
        loading: false
      };
    
    case SEARCH_USERS:
      return {
        ...state,
        searchResults: action.payload,
        loading: false
      };
    
    case CLEAR_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: [],
        loading: false
      };

    case SEND_FRIEND_REQUEST:
      return {
        ...state,
        loading: false
      };
    
    case ACCEPT_FRIEND_REQUEST:
      return {
        ...state,
        friendRequests: state.friendRequests.filter(
          request => request.from._id !== action.payload
        ),
        loading: false
      };
    
    case REJECT_FRIEND_REQUEST:
      return {
        ...state,
        friendRequests: state.friendRequests.filter(
          request => request.from._id !== action.payload
        ),
        loading: false
      };
    
    case REMOVE_FRIEND:
      return {
        ...state,
        friends: state.friends.filter(
          friend => friend._id !== action.payload
        ),
        loading: false
      };
    
    case FRIEND_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    
    case CLEAR_FRIENDS:
      return {
        ...state,
        friends: [],
        friendRequests: [],
        searchResults: [],
        loading: false
      };
    
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null
      };
    
    default:
      return state;
  }
};